import { AppShell, type AppShellProps } from './AppShell';

export type AlunoShellProps = Omit<AppShellProps, 'layoutVariant'>;

/** Portal do aluno: mesmo shell que o admin (logo, sidebar, padding do header), com barra de pesquisa no lugar do título da página. */
export function AlunoShell(props: AlunoShellProps) {
  return <AppShell {...props} layoutVariant="student" />;
}
